import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <img
        src="/brand/eduborg-mascot.png"
        alt="EduBorg looking for the page"
        width={120}
        height={120}
        className="animate-mascot-idle opacity-90"
      />
      <h1 className="font-display text-4xl font-bold">EduBorg can't find that page.</h1>
      <p className="max-w-md text-muted-foreground">
        It might have been moved, or maybe it never existed. Let's get you back home.
      </p>
      <Link
        to="/"
        className="rounded-lg bg-accent px-5 py-3 text-sm font-semibold text-accent-foreground shadow-sm transition-shadow hover:shadow-md"
      >
        Back to EduBorg
      </Link>
    </div>
  );
}
